import { render, staticRenderFns } from "./TypeoperationsNews_Headers.vue?vue&type=template&id=150077c1&"
import script from "./TypeoperationsNews_Headers.vue?vue&type=script&lang=js&"
export * from "./TypeoperationsNews_Headers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports